import React from 'react';

const SectionRule = () => (
    <div className='my-8'>
        <hr />
    </div>
);

export default SectionRule;
